/** @format */
import { ChangeDetectionStrategy, Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { LearningEnvironmentUrl } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { LocaleService } from 'sis-common';

@Component({
    selector: 'app-learning-environments',
    template: `
        @if (visibleLinks?.length) {
            <div class="d-flex flex-column">
                @for (link of visibleLinks; track link) {
                    <a fudisLink [href]="link.url" [external]="true" [title]="link.name"></a>
                }
            </div>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LearningEnvironmentsComponent {
    private readonly localeService = inject(LocaleService);

    visibleLinks: LearningEnvironmentUrl[];

    @Input({ required: true }) set learningEnvironments(learningEnvironments: LearningEnvironmentUrl[]) {
        if (learningEnvironments?.length) {
            const languagePrecedence = new Set([this.localeService.getCurrentLanguage(), ...this.localeService.getOfficialLanguages()]);
            for (const language of languagePrecedence) {
                const links = learningEnvironments.filter(link => link.language === language);
                if (links.length > 0) {
                    this.visibleLinks = _.orderBy(links, 'primary', 'desc');
                    break;
                }
            }
        }
    }
}
